import { render, staticRenderFns } from "./leftTop.vue?vue&type=template&id=1328b278&scoped=true&"
import script from "./leftTop.vue?vue&type=script&lang=js&"
export * from "./leftTop.vue?vue&type=script&lang=js&"
import style0 from "./leftTop.vue?vue&type=style&index=0&id=1328b278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328b278",
  null
  
)

export default component.exports